

























import store from '@/store'
import ApiClient from '@/js/api.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import Pager from '@/views/molecules/Pager.vue'
import BackButton from '@/views/atoms/BackButton.vue'

export default
  components: {
    Pankuzu
    Title
    ManageBase
    ManageTemplate
    BackButton
    Pager
  }

  watch: {
    $route: (to, from) ->
      @getList(@.$route.params.page)
  }

  data: () ->
    nowPoint: 0
    pointList: []
    pager: null

  created: () ->
    @getList(1)
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    store.dispatch('setBackURL', '/mypage/point_history')

  methods: {
    getList: (page) ->
      api = new ApiClient()
      data = await api.get('/member/point/list/' + page)
      @nowPoint = data.total_point
      @pointList = data.list
      @pager = data.page
    go_back: () ->
      @$router.push '/mypage'
  }

